export const REQUEST_ERROR_EVENT = 'tuui:request-error';

export function emitRequestError(detail) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(REQUEST_ERROR_EVENT, {
      detail: {
        severityScore: 'error',
        ...detail,
      },
    })
  );
}
